module.exports = __webpack_public_path__ + "static/img/7.1f8f177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/7.jpg
// module id = KCV0
// module chunks = 1